import { debounce } from "../../@helpers/js/queue-processing.js";

import initViewportHeight from "./handleViewportHeights.js";
import NavContainer from "./handleNavContainer.js";
const { initMenuButton, toggleNavigation } = NavContainer;
import Shared from "./shared.js";
const {
  isMobileMenuOpen,
  isAnySubmenuOpen,
  closeAllSubmenus,
} = Shared;
import initNavDomain from "./handleNavDomain.js";
import Overlay from "./handleOverlay.js";
const { initOverlay, reevaluateOverlay } = Overlay;
import {searchMobileisOpen, clickToggleSearchMobile} from "./handleSearch.js";
import Submenus from "./handleSubmenus.js";
const { initSubmenus, calcSubNavsWidth } = Submenus;

class Navigation {
  constructor(element) {
    this._element = element;

    this.init();
  }

  init() {
    let cachedWidth = window.innerWidth;
    initViewportHeight();
    initMenuButton();
    initNavDomain();
    initOverlay();
    initSubmenus();

    window.addEventListener(
      "resize",
      debounce(() => {
        // catch unexpected resize events (IOS/Android scroll)
        if (cachedWidth === window.innerWidth) {
          return;
        }
        cachedWidth = window.innerWidth;

        if (isAnySubmenuOpen()) {
          closeAllSubmenus();
        }

        if (searchMobileisOpen()) {
          clickToggleSearchMobile();
        }

        if (isMobileMenuOpen()) {
          toggleNavigation("close");
        }

        reevaluateOverlay();
        calcSubNavsWidth();
      }, 250)
    );
  }
}

export default Navigation;
